export default "__VITE_ASSET__C76angF2__"